import { createApiCall } from 'lib/base';

const FETCH_HOME_WIDGET_EDIT_API_ID = 'DASHBOARD/FETCH_HOME_WIDGET_EDIT_API';

const apiCall = createApiCall(FETCH_HOME_WIDGET_EDIT_API_ID, ({ id, payload }) => ({
  endpoint: `/api/admin/home-widgets/${id}`,
  method: 'PATCH',
  body: payload,
  notify: true,
}));

export default apiCall;
